import styles from '../CaseStudyLarge.module.scss'

export interface CaseStudySliderItem {
  src: string
  logo: string
  title: string
  problem: string
  caseName: string
  client: string
  term: string
  overview: string
}

interface Props {
  caseStudySliderList: CaseStudySliderItem
}

const PCCaseStudyList: React.FC<Props> = ({ caseStudySliderList }) => {
  return (
    <>
      <div className={styles.list_wrapper} key={caseStudySliderList.title}>
        <div className={styles.list_container}>
          <div className={styles.image_container}>
            <div className={styles.img} style={{ backgroundImage: `url(${caseStudySliderList.src})` }} />
          </div>
          <div className={styles.text_container}>
            <div className={styles.title_group}>
              <div className={styles.logo_group}>
                <img src={caseStudySliderList.logo} alt={caseStudySliderList.client} className={styles.logo} />
              </div>
              <h2 className={styles.title}>{caseStudySliderList.title}</h2>
            </div>
            <ul className={styles.case_lists}>
              {(() => {
                if (caseStudySliderList.problem !== '/') {
                  return (
                    <li className={styles.case_list}>
                      <span className={styles.titles}>Problem/Want</span>
                      <p className={styles.text}>{caseStudySliderList.problem}</p>
                    </li>
                  )
                }
              })()}
              <li className={styles.case_list}>
                <span className={styles.titles}>Solution</span>
                <p className={styles.text}>{caseStudySliderList.caseName}</p>
              </li>
              {(() => {
                if (caseStudySliderList.term !== '/') {
                  return (
                    <li className={styles.case_list}>
                      <span className={styles.titles}>Term</span>
                      <p className={styles.text}>{caseStudySliderList.term}</p>
                    </li>
                  )
                }
              })()}
              <li className={styles.case_list}>
                <span className={styles.titles}>Client</span>
                <p className={styles.text}>{caseStudySliderList.client}</p>
              </li>
              <li className={styles.case_list}>
                <span className={styles.titles}>Overview</span>
                <p className={styles.text}>{caseStudySliderList.overview}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default PCCaseStudyList
